var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextBody = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _dsWeb = require("@olxbr/ds-web");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var TextBody = (0, _styledComponents["default"])(_dsWeb.Text.BodyMedium)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.isMobile ? 'var(--font-size-xxs)' : 'var(--font-size-xs)';
}, function (props) {
  return props.isMobile ? 'var(--font-lineheight-tight)' : 'var(--font-lineheight-superdistant)';
});
exports.TextBody = TextBody;